import {config} from "../../config";
import {setAuthorization} from "../../common/api/base";
import {matchPath, Redirect, useLocation} from "react-router-dom";
import {RouteDefine} from "../../routes/RouteDefine";
import React from "react";
import {QHelpers} from "../../common/helpers";
import {GeneralConstant} from "../../common/constant/GeneralConstant";
import {adminRoutes} from "../../routes/adminRoute";
import {RouteInterface} from "../../interfaces/RouteInterface";
import {resolveOnboardingPath, resolveOnboardingStep} from "../../common/helpers/onboardingResume";

const AuthProtected = (props: any) => {

    const location = useLocation();

    const token: string | any = QHelpers.store.getAccessToken();
    setAuthorization(token);

    const role = QHelpers.string.decrypt(
        QHelpers.store.localStorageGetItem(config.LOCAL_STORE.ROLE)
    );


    let matchIsAdmin = adminRoutes.find((route: RouteInterface) => {
        return matchPath(location.pathname, {
            path: route.path,
            exact: true,
            strict: false
        });
    })

    if (
        role === GeneralConstant.user.role.super_admin
        && !QHelpers.store.getImpersonationToken()
        && !matchIsAdmin
    ) {
        return (
            <Redirect to={RouteDefine.admin}/>
        );
    }

    if (!token) {
        return (
            <Redirect to={{pathname: RouteDefine.login, state: {from: props.location}}}/>
        );
    }

    const accountData = JSON.parse(QHelpers.store.localStorageGetItem(config.LOCAL_STORE.ACCOUNT) ?? '{}');
    const onboardingStep = resolveOnboardingStep(accountData);
    const isOnSetup = matchPath(location.pathname, {
        path: RouteDefine.setup,
        exact: true,
        strict: false
    });
    const isOnConfig = matchPath(location.pathname, {
        path: RouteDefine.config,
        exact: true,
        strict: false
    });

    const isOnDashboard = matchPath(location.pathname, {
        path: RouteDefine.dashboard,
        exact: true,
        strict: false
    });
    const isImpersonating = Boolean(QHelpers.store.getImpersonationToken());

    // Incomplete onboarding: force resume destination (Stripe → Confirm, else Setup).
    // Allow /dashboard (post-login landing), /setup and /config without bouncing to Confirm.
    if (
        !isImpersonating
        && onboardingStep !== -1
        && !isOnSetup
        && !isOnConfig
        && !isOnDashboard
    ) {
        const resumePath = resolveOnboardingPath(accountData);
        if (resumePath === RouteDefine.confirm) {
            return <Redirect to={RouteDefine.confirm}/>;
        }
        return <Redirect to={RouteDefine.setup}/>;
    }

    return <>{props.children}</>;
};

export default AuthProtected
